import React from 'react';
import { BaseCardContent } from '../MessageType';
import { AppDetailClickable } from './AppDetailTip';

interface QuickContractCardViewProps {
  content: BaseCardContent;
}

/** 聊天内闪电合约仅展示卡片 JSON，不请求 contract 接口（避免无关 toast） */
export const QuickContractCardView: React.FC<QuickContractCardViewProps> = ({
  content,
}) => {
  const contractId = (content.contractId as string) || '';
  const contractNo =
    (content.contractNo as string) || contractId;
  const contractContent = (content.contractContent as string) || '';
  const posterName =
    (content.posterName as string) || String(content.posterId || '');
  const signerName =
    (content.signerName as string) || String(content.signerId || '');

  return (
    <AppDetailClickable>
      <div className="message-card message-contract-card">
        <div className="message-contract-header">
          <span className="message-contract-title">闪电合约</span>
          <span className="message-contract-no">{contractNo}</span>
        </div>
        <div className="message-contract-content">{contractContent}</div>
        <div className="message-contract-meta">
          <div>发起人：{posterName}</div>
          <div>签署人：{signerName}</div>
        </div>
        <div className="message-contract-footer">闪电合约同样具备法律效力。</div>
        <div className="message-order-hint">点击前往 APP 查看详情</div>
      </div>
    </AppDetailClickable>
  );
};
